import React from "react";
import { Image, Wrapper } from "./MainImage.styles";

const MainImage = () => {
  return (
    <Wrapper>
      <Image />
    </Wrapper>
  );
};

export default MainImage;
